import { render, staticRenderFns } from "./view-facture.html?vue&type=template&id=52ecafd0&scoped=true&external"
import script from "./view-facture.js?vue&type=script&lang=js&external"
export * from "./view-facture.js?vue&type=script&lang=js&external"
import style0 from "./view-facture.scss?vue&type=style&index=0&id=52ecafd0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecafd0",
  null
  
)

export default component.exports